import { render, staticRenderFns } from "./RespostaShow.vue?vue&type=template&id=1825e6b6&scoped=true&"
import script from "./RespostaShow.vue?vue&type=script&lang=js&"
export * from "./RespostaShow.vue?vue&type=script&lang=js&"
import style0 from "./RespostaShow.vue?vue&type=style&index=0&id=1825e6b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1825e6b6",
  null
  
)

export default component.exports